import lrButtons from './_src/lrButtons.vue'

lrButtons.install = function(Vue) {
  Vue.component(lrButtons.name, lrButtons)
}

export default lrButtons